module.exports = __webpack_public_path__ + "img/select-user.510e9522.png";